'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var styleHelper = require('../../helper/styleHelper');
var measureHelper = require('../../helper/measureHelper');
var CheckIcon = require('../common/CheckIcon');
var RadioIcon = require('../common/RadioIcon');
var assetsHelper = require('../../helper/assetsHelper');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');

/**
 * Tabel
 * @author mxj
 * @createDate 2016/9/6
 *
 * @descriptor 列宽的计算方式，
 *  1、计算出所有列最大宽度，及其相加的总和
 *  2、计算所有列的宽度比例，及其比例总和
 *  3、如果总和大于0 小于 100时，较正各列的比较值
 *  4、如果部比例为0时，
 *    a ：如果总宽度为０，则，各列平分组件宽度
 *    b : 如果总宽度不为0，则各列平分比例，并根据比例计算出各列的宽度
 *  *** 需要注意的是，如果有换行的情况下，如何测量出正确的列宽
 *
 *  cellDatas :[
 *    {
 *      columns : [
 *        {
 *          text : string|NaN,
 *          width : number|NaN,
 *          type : 'none|text|up|down|up-down|check-off|check-on|select_off|select-on'
 *        },{},...
 *      ],
 *      rowHeight : px
 *    },{},...
 *  ]
 **/

var Tabel = React.createClass({
  propTypes: {},

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    }
  },

  cellType: {
    text: 'text',
    checkOn: 'check-on',
    checkOff: 'check-off',
    selectOn: 'select-on',
    selectOff: 'select-off'
  },

  orderType: {
    none: 'none',
    up: 'up',
    down: 'down',
    up_down: 'up-down'
  },

  upIcon: 'upicon.png',

  downIcon: 'downicon.png',

  upAndDownIcon: 'updownicon.png',

  render: function () {
    this.showVLine = styleHelper.getPropertyValue(this.props, propConst.SHOW_V_LINE);
    this.showHLine = styleHelper.getPropertyValue(this.props, propConst.SHOW_H_LINE);
    var h = styleHelper.getHeight(this.props);
    var borderVisible = styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var showHeader = styleHelper.getPropertyValue(this.props, propConst.SHOW_HEADER);
    var borderColor = styleHelper.getBorderColor(this.props);

    var style = {
      backgroundColor: bgColor,
      borderStyle: borderVisible ? 'solid' : 'none',
      borderColor: borderColor,
      color: styleHelper.getTextColor(this.props),
      letterSpacing: -1,
      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family),
    };
    var scrollTop = 0;
    var selfH = h;
    var scrollHeight = selfH;


    this.parseCells();

    if (showHeader) {
      scrollTop = this.headDatas.height + 5;
      scrollHeight = selfH - scrollTop - 5;
    }

    return (
      <div className="component border" style={style}>
        <table ref="tabel" frameBorder={'border'}
               width="100%"
               colSpan={6}
               rowSpan={0}
               cellSpacing={0}>

          {
            this.headDatas && (
              <thead>
              <tr ref="headRow" height={this.headDatas.height} style={this.headStyle()}
                  onClick={this.rowClick.bind(this, true, 0)}>
                {
                  this.headDatas.cells.map(function (td, index) {
                    return (
                      <td key={"head-td" + index} style={this.cellStyle(td, this.headDatas.height, index)}>
                        {
                          td.type === this.cellType.text && this.renderTextCell(td, index)
                        }
                        {
                          td.type === this.cellType.checkOn &&
                          <CheckIcon key={'head-td-check-' + index}
                                     position="relative"
                                     isChecked="true" enabled="false"/>
                        }
                        {
                          td.type === this.cellType.checkOff &&
                          <CheckIcon key={'head-td-check-' + index}
                                     position="relative"
                                     enabled="false"/>
                        }
                        {
                          td.type === this.cellType.selectOn &&
                          <RadioIcon key={'head-td-radio-' + index}
                                     position="relative"
                                     isSelected="true" enabled="false"/>
                        }
                        {
                          td.type === this.cellType.selectOff &&
                          <RadioIcon key={'head-td-radio-' + index} position="relative"
                                     enabled="false"/>
                        }
                        {
                          td.order
                          && td.order !== this.orderType.none
                          && <img width="10" height="10"
                                  ref={'headIcon-' + index}
                                  src={this.getHeaderIcon(td)}
                                  style={this.headIconStyle(index)}/>
                        }
                      </td>
                    );
                  }, this)
                }
              </tr>
              </thead>
            )
          }
          <tbody>
          {
            this.cellDatas.map(function (row, index) {
              return (
                <tr key={'body-row-' + index} style={this.rowStyle(row, index)}
                    onClick={this.rowClick.bind(this, false, index)}>
                  {
                    row.cells.map(function (cel, i, arr) {
                      return (
                        <td key={index + '-' + i} style={this.cellStyle(cel, row.height, i)}>
                          {
                            cel.type === this.cellType.text && this.renderTextCell(cel, i)
                          }
                          {
                            cel.type === this.cellType.checkOn &&
                            <CheckIcon key={'body-td-check-' + index + '-' + i}
                                       position="relative"
                                       isChecked="true"
                                       enabled="false"/>
                          }
                          {
                            cel.type === this.cellType.checkOff &&
                            <CheckIcon key={'body-td-check-' + index + '-' + i}
                                       position="relative"
                                       enabled="false"/>
                          }
                          {
                            cel.type === this.cellType.selectOn &&
                            <RadioIcon key={'body-td-radio-' + index + '-' + i}
                                       position="relative"
                                       isSelected="true"
                                       enabled="false"/>
                          }
                          {
                            cel.type === this.cellType.selectOff &&
                            <RadioIcon key={'body-td-radio-' + index + '-' + i}
                                       position="relative"
                                       enabled="false"/>
                          }
                        </td>
                      )
                    }, this)
                  }
                </tr>
              )
            }, this)
          }
          </tbody>
        </table>
        {
          this.props.verticalScrollbarShow &&
          <VerticalScrollBar
            key="scrollbar"
            value={parseInt(this.props.verticalScrollbarProgress, 10)}
            top={scrollTop}
            height={scrollHeight}
            zIndex={1}
          />
        }
      </div>
    );
  },

  /**
   * 单元格内容渲染
   * @param cel
   * @param index
   * @returns {*|Object|Array}
   */
  renderTextCell: function (cel, index) {
    var text = cel.text;
    var strs = util.Text.delimitToParagraphs(text);
    var cellWith = this.getCellWidth(index);
    var textStyle = {
      height: 'auto',
      overflow: 'hidden',
      wordBreak: 'break-all',
      whiteSpace: 'nowrap'
    };
    if (typeof cellWith === 'string' && cellWith.indexOf('%') !== -1) {
      var width = parseInt(this.props.w, 10) * parseInt(cellWith, 10) / 100 - 10;
      textStyle.width = width;
    } else if (typeof cellWith === 'number') {
      textStyle.width = cellWith - 10;
    }
    return strs.map(function (str, i) {
      return (<p key={i} style={textStyle}>{util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(str))}</p>)
    })
  },

  getHeaderIcon: function (td) {
    var src;
    if (td) {
      if (td.order === this.orderType.up) {
        src = this.upIcon;
      } else if (td.order === this.orderType.down) {
        src = this.downIcon;
      } else if (td.order === this.orderType.up_down) {
        src = this.upAndDownIcon;
      }
    }
    if (src) {
      src = assetsHelper.getAssistAsset(src);
    }
    return src;
  },

  headIconStyle: function (index) {
    var style = {
      width: 10,
      height: 10,
      top: (this.headDatas.height - 10) / 2 + 2,
      position: 'absolute'
    };
    var i = 0;
    var l = 0;
    for (i = 0; i <= index; i++) {
      l += this.columnWidth[i];
    }
    style.left = l - 20;
    return style;
  },

  headStyle: function () {
    var style = {
      backgroundColor: 'inherit',
      height: this.headDatas.height + 3,
      boxSizing: 'border-box'
    };
    if (this.props.showHeader) {
      style.backgroundColor = this.props.headerColor ;
      style.height = this.headDatas.height - 3;
      style.fontColor = this.props.headerTextColor
    } else {
      if (this.state.selectedIndex === 0) {
        style.backgroundColor = this.props.selectedColor;
      }
    }
    return style;
  },

  measureLineHeight: function () {
    if (!this.isMeasured) {
      var lineHeight = styleHelper.builderLineHeight(this.props);
      if (lineHeight) {
        return lineHeight + 'px';
      }
    }
    return '1em';
  },

  /**
   * 单元格 style
   * @param td
   * @param height
   * @param index
   * @returns {*|{borderBottomStyle, borderRightStyle, borderColor, fontSize, fontFamily, fontWeight, fontStyle, textDecoration}}
   */
  cellStyle: function (td, height, index) {
    var isEnd = index === this.maxColumnCount - 1;
    var style = this.tdStyle(isEnd);
    style.textAlign = this.columnConfig[index].align;
    style.height = height || 'inherit';

    style.width = this.getCellWidth(index);
    if (td.text) {
      if (util.Text.isMultiLineText(td.text)) {
        style.lineHeight = this.measureLineHeight();// this.props.textSize + 'px';
        // style.whiteSpace = 'normal';
      } else {
        // style.whiteSpace = 'nowrap'
      }
    }
    return style;
  },

  /**
   * 单元格宽度
   * @param index
   * @returns {*}
   */
  getCellWidth: function (index) {
    /*2.2.8版本与2.2.9兼容处理处*/
    //if (!this.props.columnRatio) {
      return this.columnWidth[index] - 5;
    //}
    //var columnRatio = this.props.columnRatio.substr(1, this.props.columnRatio.length - 2);
    //var colList = columnRatio.split(',');
    //return colList[index] + '%';
  },

  /**
   * 行 style
   * @param td
   * @param index
   * @returns {{backgroundColor: string, height: number, boxSizing: string, lineHeight}}
   */
  rowStyle: function (td, index) {
    var condition = false;
    var bg = 'inherit';
    var i = index + 1;

    if (this.props.isInterlace) {
      if (this.props.showHeader) {
        condition = index % 2 !== 0
      } else {
        condition = index % 2 === 0;
      }
    }
    if (i === this.state.selectedIndex) {
      bg = this.props.selectedColor;
    } else {
      if (condition) {
        bg = this.props.interlaceColor;
      }
    }


    return {
      backgroundColor: bg,
      height: td.height - 3,
      boxSizing: 'border-box',
      lineHeight: td.lineHeight
    }
  },

  tdStyle: function (isEnd) {
    return {
      borderBottomStyle: this.showHLine ? 'solid' : 'none',
      borderRightStyle: this.showVLine ? (isEnd ? 'none' : 'solid') : 'none',
      /*borderColor: styleHelper.getBorderColor(this.props),*/
      borderColor: this.props.separatorColor,
      fontSize: styleHelper.getFontSize(this.props),
      fontFamily: this.props.textFontFamily,
      fontWeight: this.props.textStyles.fontWeight,
      fontStyle: this.props.textStyles.fontStyle,
      textDecoration: this.props.textStyles.textDecoration
    }
  },


  bodyContext: undefined,

  configText: undefined,

  headText: undefined,

  columnConfig: [],

  headDatas: undefined,

  cellDatas: [],

  columnWidth: [], /*求值结果参数*/

  maxColumnCount: 0,

  validRowCount: 0,

  parseRow: function (rowStr) {
    var cells = [];
    var rowArr;
    var text;
    var i;
    var d;
    var originalText;
    var rowConfig = {
      height: this.props.itemHeight,
      cells: cells
    };
    if (rowStr) {
      rowArr = util.Text.delimitText(rowStr, util.Text.DM_COMMA);
      for (i = 0; i < rowArr.length; i++) {
        originalText = rowArr[i];
        originalText = rowArr[i].replace('\\r', '\n');
        text = rowArr[i].trim().replace('\\r', '\n');
        if (util.Text.compareTo(text, '[]', false) || util.Text.compareTo(text, '[ ]', true)) {
          d = {
            text: util.Text.replaceLast(text, ['[]', '[ ]']),
            type: this.cellType.checkOff
          }
        } else if (util.Text.compareTo(text, '[x]', true) || util.Text.compareTo(text, '[X]', true)) {
          d = {
            text: util.Text.replaceLast(text, '[x]'),
            type: this.cellType.checkOn
          }
        } else if (util.Text.compareTo(text, '()', true) || util.Text.compareTo(text, '( )', true)) {
          d = {
            text: util.Text.replaceLast(text, ['()', '( )']),
            type: this.cellType.selectOff
          }
        } else if (util.Text.compareTo(text, '(o)', true)) {
          d = {
            text: util.Text.replaceLast(text, '(o)'),
            type: this.cellType.selectOn
          }
        } else {
          d = {
            text: text,
            type: this.cellType.text
          }
        }
        d.originalText = originalText;
        cells.push(d);
      }
    }
    this.cellDatas.push(rowConfig);
  },

  parseColumnConfig: function () {
    var i;
    var str;
    var props = this.props;

    function parseCellConfig(cfgStr) {
      var cfg = {
        scale: 0,
        align: styleHelper.builderTextAlign(props).textAlign
      };
      var w;
      var v;
      if (cfgStr) {
        cfgStr = cfgStr.trim();

        v = cfgStr[cfgStr.length - 1];
        w = cfgStr.replace(v, '');
        if (w) {
          cfg.scale = parseInt(w);
        }
        if (v) {
          v = v.toUpperCase();
          switch (v) {
          case 'C' :
            cfg.align = 'center';
            break;
          case 'L' :
            cfg.align = 'left';
            break;
          case 'R' :
            cfg.align = 'right';
            break;
          }
        }
      }
      return cfg;
    }

    i = 0;
    this.columnConfig = [];
    if (this.configText) {
      str = this.configText.replace('{', '').replace('}', '');
      str = util.Text.delimitText(str, util.Text.DM_COMMA);
      this.maxColumnCount = Math.max(this.maxColumnCount, str.length);
      var itm;

      for (i = 0; i < str.length; i++) {
        itm = str[i].trim();
        this.columnConfig.push(parseCellConfig(itm));
      }
    } else {
      for (i = 0; i < this.maxColumnCount; i++) {
        this.columnConfig.push(parseCellConfig());
      }
    }
    if (i < this.maxColumnCount) {
      for (i; i < this.maxColumnCount; i++) {
        this.columnConfig.push(parseCellConfig());
      }
    }
  },

  parseHeadCell: function (td) {
    var h = {
      text: '',
      originalText: td,
      type: this.cellType.text
    };
    if (td) {
      td = td.trim().replace('\\r', '\n');
      if (util.Text.ansiEndsStr(td, '^v')) {
        h.order = this.orderType.up_down;
        h.text = td.substring(0, td.length - 2);
      } else if (util.Text.ansiEndsStr(td, 'v')) {
        h.order = this.orderType.down;
        h.text = td.substring(0, td.length - 1);
      } else if (util.Text.ansiEndsStr(td, '^')) {
        h.order = this.orderType.up;
        h.text = td.substring(0, td.length - 1);
      } else if (util.Text.compareTo(td, '[]', true) || util.Text.compareTo(td, '[ ]', true)) {
        h.type = this.cellType.checkOff;
      } else if (util.Text.compareTo(td, '[x]')) {
        h.type = this.cellType.checkOn;
      } else if (util.Text.compareTo(td, '()', true) || util.Text.compareTo(td, '( )', true)) {
        h.type = this.cellType.selectOff;
      } else if (util.Text.compareTo(td, '(o)', true)) {
        h.type = this.cellType.selectOn
      } else {
        h.type = this.cellType.text;
        h.text = td;
      }
    }
    if (!h.text) {
      if (td) {
        h.originalText = td.replace(/ /g, '\u0a00');
      }
    } else {
      h.text = h.text.trim();
    }
    return h;
  },

  parseHead: function (str) {
    var i = 0;
    var endStr;
    var arr;
    var td;
    var cells;

    arr = util.Text.delimitText(str, util.Text.DM_COMMA);
    cells = [];
    this.headDatas = {
      height: 0,
      cells: cells
    };
    for (i; i < arr.length; i++) {
      td = arr[i];
      cells.push(this.parseHeadCell(td));
    }
    for (i; i < this.maxColumnCount; i++) {
      cells.push(this.parseHeadCell(''));
    }

  },

  fitCellDatas: function () {
    var i;
    var j;
    var row;

    var maxRowCount = styleHelper.getHeight(this.props) / this.props.itemHeight;
    i = this.cellDatas.length;
    var emptyRow = {
      height: this.props.itemHeight,
      cells: []
    };
    for (i; i < maxRowCount; i++) {
      this.cellDatas.push(emptyRow);
    }
    i = 0;
    for (i; i < this.cellDatas.length; i++) {
      row = this.cellDatas[i];
      j = row.cells.length;
      for (j; j < this.maxColumnCount; j++) {
        row.cells.push({text: '', type: 'text'});
      }
    }
    i = this.headDatas.cells.length;
    for (i; i < this.maxColumnCount; i++) {
      this.headDatas.cells.push(this.parseHeadCell());
    }
  },

  isConfigText: function (str) {
    var r = false;
    if (str && str.length) {
      r = util.Text.ansiStartsStr(str.trim(), '{');
      if (r) {
        r = util.Text.ansiEndsStr(str.trim(), '}');
      }
    }
    return r;
  },

  measureCell: function (text) {
    var style = {
      fontSize: this.props.textSize,
      fontStyle: this.props.textStyles.fontStyle,
      textDecoration: this.props.textStyles.textDecoration,
      fontWeight: this.props.textStyles.fontWeight,
      fontFamily: this.props.textStyles.fontFamily/*,
       letterSpacing : -1*/
    };
    return measureHelper.measureTextWidth(style, text);
  },

  initHeaderHeight : function(){
    var links = this.props.links.link;
    var link = links[0];
    this.headDatas.height = link.area.coords.height - 3;
  },
  /*
   * 默认计算
   * */
  measureColumns: function () {
    var i;
    var j;
    var row;
    var cell;
    var text;
    var w;
    var h;
    var size;
    var links = this.props.links.link;
    var link;
    var l;
    var maxWidth = 0;
    var scaleW;
    var selfW = styleHelper.getWidth(this.props);
    var lockW;
    this.columnWidth = [];
    for (i = 0; i < this.maxColumnCount; i++) {
      this.columnWidth.push(0);
    }
    for (i = 0; i < this.cellDatas.length; i++) {
      row = this.cellDatas[i];
      for (j = 0; j < row.cells.length; j++) {
        cell = row.cells[j];
        text = cell.originalText;
        if (text) {
          size = this.measureCell(text);
          w = size.width;
          maxWidth = Math.max(w, this.columnWidth[j]);
          this.columnWidth[j] = maxWidth;
        }
      }

      maxWidth = 0;
    }
    i = 0;
    for (i = 0; i < this.headDatas.cells.length; i++) {
      cell = this.headDatas.cells[i];
      text = cell.originalText;
      if (text) {
        w = this.measureCell(text).width;
        this.columnWidth[i] = Math.max(this.columnWidth[i], w);
      }
    }

    i = 1;

    l = this.cellDatas.length + i;
    j = 0;
    for (i; i < links.length; i++) {
      link = links[i];
      if (j < this.cellDatas.length) {
        this.cellDatas[j].height = link.area.coords.height - 3;
        this.cellDatas[j].lineHeight = this.cellDatas[j].height + 'px';
      }
      j++;
    }


    scaleW = 0;
    for (i = 0; i < this.columnConfig.length; i++) {
      scaleW += this.columnConfig[i].scale;
    }
    lockW = 0;
    if (scaleW !== 0 && scaleW !== 100) {

      for (i = 0; i < this.columnConfig.length; i++) {
        w = this.columnConfig[i].scale;
        w = w * (100 / scaleW);
        this.columnConfig[i].scale = w;
        if (w === 0) {
          lockW += this.columnWidth[i];
        }
      }
    } else if (scaleW === 0) {
      w = 0;
      for (i = 0; i < this.columnWidth.length; i++) {
        w += this.columnWidth[i];
      }
      if (w === 0) {
        w = selfW;
      }

      for (i = 0; i < this.columnConfig.length; i++) {
        this.columnConfig[i].scale = this.columnWidth[i] * 100 / w;
      }
    }
    selfW -= lockW;
    if (this.props.verticalScrollbarShow) {
      selfW -= 20;
    }
    for (i = 0; i < this.columnConfig.length; i++) {
      if (this.columnConfig[i].scale !== 0) {
        this.columnWidth[i] = selfW * Math.round(this.columnConfig[i].scale * 10) / 1000;
      }
    }
  },

  calculateMaxColumn: function () {
    this.maxColumnCount = this.headDatas.cells.length;
    var i = 0;
    var j;
    var row;
    for (i; i < this.cellDatas.length; i++) {
      row = this.cellDatas[i];
      this.maxColumnCount = Math.max(this.maxColumnCount, row.cells.length);
    }
  },


  isValidateColumnRatio : function(v){
    if(_.isUndefined(v) || _.isEmpty(v)){
      return false;
    }

    v = v.replace(/\{|\}/g,'');
    var i;
    var arr = util.Text.delimitToWords(v,false);
    if(arr.length < this.maxColumnCount)
      return false;
    for(i = 0;i<arr.length;i++){
      if(util.Int(arr[i].trim()) === 0){
        return false;
      }
    }
    return true;
  },

  measureCellWidthWithColumnRatio:function(v){
    var w = styleHelper.getWidth(this.props);
    var ratios = v.replace(/\{|\}/g,'');
    var r;
    var i;
    ratios = util.Text.delimitToWords(ratios,false);
    this.columnWidth = [];
    for(i = 0;i<ratios.length;i++){
      r = ratios[i].trim();
      r = util.Float(r)/100;
      r = r * w;
      this.columnWidth.push(r);
    }
  },

  parseCells: function () {
    var text = util.Text.removeLastEmptyRow(this.props.text);
    var columnRatio = this.props.columnRatio;
    this.cellDatas = [];

    var rowStrs = util.Text.delimitText(text, util.Text.DM_RETURN);
    var i;
    this.validRowCount = rowStrs.length;
    for (i = 0; i < rowStrs.length; i++) {
      if (i === 0) {
        this.headText = rowStrs[i];
        continue;
      } else if (i === rowStrs.length - 1) {
        if (this.isConfigText(rowStrs[i])) {
          this.configText = rowStrs[i];
          this.validRowCount -= 1;
          break;
        }
      }
      this.parseRow(rowStrs[i])
    }

    this.parseHead(this.headText);
    this.calculateMaxColumn();
    this.parseColumnConfig();
    this.fitCellDatas();
    if(this.isValidateColumnRatio(columnRatio)){
      this.measureCellWidthWithColumnRatio(columnRatio);
    }else {
      this.measureColumns();
    }
    this.initHeaderHeight();
  },

  rowClick: function (isHead, index) {

    if (isHead) {
      this.setState({selectedIndex: index})
    } else {
      if (index + 1 >= this.validRowCount) {
        return;
      }
      this.setState({selectedIndex: index + 1})
    }
  },

  onItemClick: function (e, index) {
    this.setState({
      selectedIndex: index
    });
  },

  doAdjustHeadIconPoint: function () {
    var row = ReactDOM.findDOMNode(this.refs.headRow);
    var img;
    var td;
    var i;
    if (row) {
      for (i = 0; i < row.childElementCount; i++) {
        td = row.children[i];
        img = ReactDOM.findDOMNode(this.refs['headIcon-' + i]);
        if (img) {
          $(img).css({left: td.offsetLeft + td.clientWidth - 12})
        }
      }
    }
  },

  doAdjustRowHeight: function () {
    var link = this.props.links.link;
    var item;
    var tr;
    var rows;
    var i;
    var itemHeight = this.props.itemHeight;
    var rowHeight;
    var tabel = ReactDOM.findDOMNode(this.refs.tabel);
    //var t = 0;
    //var h = styleHelper.getHeight(this.props);
    rows = $(tabel).find('tr');
    for (i = 0; i < rows.length; i++) {
      tr = rows[i];
      if (i < link.length) {
        item = link[i];
        rowHeight = item.area.coords.height;
      } else {
        rowHeight = itemHeight;
      }
      $(tr).css({height: rowHeight});
    }
  },

  doAdjustColumnWidth: function () {
  },

  doAdjust: function () {
    this.doAdjustRowHeight();
    this.doAdjustColumnWidth();
    this.doAdjustHeadIconPoint();
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
    this.doAdjust();
  },

  componentDidUpdate: function () {
    this.doAdjust();
  }
});

module.exports = Tabel;


// WEBPACK FOOTER //
// ./src/views/Components/Table.jsx